exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-common-___dashboard-tab__dashboardTabs___3SrGB {\n  display: flex;\n  flex: 0 60px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  opacity: 0;\n  transition: opacity 0.5s;\n  z-index: 50;\n}\n\n.src-components-common-___dashboard-tab__widget-item___3xi8j {\n  font-size: 14px;\n  font-weight: 300;\n  overflow: hidden;\n  white-space: nowrap;\n  line-height: 24px;\n  text-align: center;\n}\n\n.src-components-common-___dashboard-tab__center_object_H___TjlIB {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}", ""]);

// exports
exports.locals = {
	"dashboardTabs": "src-components-common-___dashboard-tab__dashboardTabs___3SrGB",
	"widget-item": "src-components-common-___dashboard-tab__widget-item___3xi8j",
	"center_object_H": "src-components-common-___dashboard-tab__center_object_H___TjlIB"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/common/dashboard-tab.scss
// module id = 2365
// module chunks = 0